/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
export const PAGE_SIZES = [5, 10, 30];
export const ASC = 'asc';
export const DESC = 'desc';
export const NONE = 'none';

export const TEN_SECONDS = 10000;

export const STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  PROVISIONING: 'provisioning',
  SUCCEEDED: 'succeeded',
  ERROR: 'error'
};
